import classNames from 'classnames'
import { PropsWithChildren } from 'react'
import { useDisableBodyScroll } from '../../../hooks/useDisableBodyScroll'
import { ModalPortal } from '../Portal/Portal'
import styles from './Modal.module.css'

type ModalProps = {
  noBackdrop?: boolean
  forceTop?: boolean
  hidden?: boolean
  lovable?: boolean
}

export const Modal: React.FC<PropsWithChildren<ModalProps>> = ({ hidden, noBackdrop, children, forceTop, lovable }) => {
  useDisableBodyScroll()

  if (hidden) {
    return <></>
  }
  return (
    <ModalPortal>
      <div
        className={classNames(lovable && 'LOVABLE_ROOT', styles.backdrop, !noBackdrop && styles.backdrop_darkened, forceTop && styles.forceTop)}
      >
        {children}
      </div>
    </ModalPortal>
  )
}
